import {Logic} from './Type'
export class SearchState extends Logic.Type {
    
    Top: string = ''
    Gamification: string = ''
}


// WEBPACK FOOTER //
// ./src/Logic/Search.ts